// extracted by mini-css-extract-plugin
export default {"formr":"Register_formr__cNFwk","error":"Register_error__A2s1P","btn":"Register_btn__8r80g"};